import { render, staticRenderFns } from "./TrialList.vue?vue&type=template&id=7383521e&scoped=true"
import script from "./TrialList.vue?vue&type=script&lang=ts"
export * from "./TrialList.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7383521e",
  null
  
)

export default component.exports